import type { PathsState } from '@wix/add-panel-component';
import { ActionType } from './newAddPanelActionTypes';

export const setPathsState = (pathsState: PathsState) => ({
  type: ActionType.SetPathsState,
  payload: {
    pathsState,
  },
});
